module.exports = __webpack_public_path__ + "img/zhongxinGH3.24289834.png";